<template>
  <div class="button">
    <base-button :route="route" :title="title" :fa-class="faClass"
                 class="rounded-circle link-button vh-align blue-white"
    />

    <span v-if="notif && notif > 0"
          class="rounded-circle notification white-orange vh-align"
    >
      {{ notif }}
    </span>
  </div>
</template>

<script>
import baseButton from '@/components/frontoffice/button/base'
import fa from '@/components/global/icon/fontAwesome'

export default {
  components: {
    baseButton,
    fa
  },

  props: {
    route: Object,
    title: String,
    faClass: String,
    notif: [Number, String]
  }
}
</script>
